export default __webpack_public_path__ + "static/media/Create.8e14efc8.svg";